export default "__VITE_ASSET__BQmf2YPy__"